import React, { useRef } from "react";
import { IImageCarouselProps } from "./ImageCarouselProps";
import Carousel from "react-bootstrap/Carousel";
import "lazysizes";
import { Container } from "./ImageCarouselHelpers";
import Img from "gatsby-image";
import { StaticImage } from "gatsby-plugin-image";
import { buildFluidImageData } from "@imgix/gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Swiper as SwiperCore } from "swiper/types";
import { Pagination } from "swiper/modules";
import { carouselContainer } from "../HotelCard/HotelCard.module.scss";
import {
  CarouselNextIcon,
  CarouselPrevIcon,
} from "../HotelCard/HotelCardHelpers";
import { useMediaQuery } from "../../../hooks/useMediaQuery";
export const ImageCarousel: React.FC<IImageCarouselProps> = (props) => {
  return (
    <Container>
      <Carousel
        defaultActiveIndex={props.activeImage}
        interval={null}
        slide={true}
      >
        {props.images?.map((image: any, index: number) => {
          const gatsbyImage = image.gatsbyImage
            ? getImage(image.gatsbyImage as any)
            : null;
          return (
            <Carousel.Item key={image.url + index}>
              {gatsbyImage ? (
                <GatsbyImage
                  image={gatsbyImage}
                  alt={image.alt}
                  loading="lazy"
                />
              ) : (
                <Img
                  loading="lazy"
                  fluid={buildFluidImageData(
                    image.url,
                    {
                      ar: 1.18,
                      auto: ["format", "compress"],
                    },
                    {
                      sizes: "100%",
                    }
                  )}
                  alt={image.alt}
                />
              )}
            </Carousel.Item>
          );
        })}
      </Carousel>
    </Container>
  );
};

type Image = {
  imageUrl: string;
  url: string;
  altText?: string;
};

export const NewImageCarousel: React.FC<IImageCarouselProps> = (props) => {
  const swiperRef = useRef<SwiperCore | null>(null);
  const isMobile = useMediaQuery("(max-width: 991px)");
  if (
    props.isRoomCard &&
    (!props.images || props.images.length === 0 || props.images === null)
  ) {
    return (
      <Swiper
        modules={isMobile ? [] : [Pagination]}
        style={{
          "--swiper-pagination-color": "#fff",
          position: "relative",
          height: isMobile ? "300px" : "480px",
        }}
        lazy={true}
        className="mySwiper"
        loop={true}
        slidesPerView={1}
        pagination={{ clickable: true }} // Conditional rendering of pagination
        onBeforeInit={(swiper) => {
          swiperRef.current = swiper;
        }}
      >
        <SwiperSlide>
          <StaticImage
            src="../../../images/hotel_fallback.jpg"
            alt="Default Room Image"
            style={{ height: isMobile ? "300px" : "480px", width: "100%" }}
            placeholder="blurred"
            layout="constrained"
          />
          <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
        </SwiperSlide>
      </Swiper>
    );
  }

  return props?.images?.length > 0 ? (
    <Container>
      <Swiper
        modules={isMobile ? [] : [Pagination]}
        style={{
          "--swiper-pagination-color": "#fff",
          position: "relative",
          height: isMobile ? "300px" : "480px",
        }}
        lazy={true}
        className="mySwiper"
        loop={true}
        slidesPerView={1}
        initialSlide={props?.activeImage > -1 ? props?.activeImage : 0}
        pagination={{ clickable: true }} // Conditional rendering of pagination
        onBeforeInit={(swiper) => {
          swiperRef.current = swiper;
        }}
      >
        {props.images?.map((image: Image, index: number) => {
          const imageUrl = image.imageUrl || image.url;
          const isGatsbyImage = imageUrl.startsWith("/_gatsby");
          return (
            <SwiperSlide key={`image-${index}`}>
              {isGatsbyImage ? (
                <img src={imageUrl} alt={image.altText} />
              ) : (
                <Img
                  loading="lazy"
                  fluid={buildFluidImageData(imageUrl, {
                    auto: ["format", "compress"],
                    ar: 1.18,
                  })}
                  style={{ height: isMobile ? "300px" : "480px" }}
                  alt={image.altText}
                />
              )}
              <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
            </SwiperSlide>
          );
        })}

        {props.images.length > 1 && (
          <div className={carouselContainer}>
            <CarouselPrevIcon onClick={() => swiperRef.current?.slidePrev()} />
            <CarouselNextIcon onClick={() => swiperRef.current?.slideNext()} />
          </div>
        )}
      </Swiper>
    </Container>
  ) : (
    <Container>No Images Available</Container>
  );
};
